import { sumWeights } from '@rematter/common/sumWeights';
import { maybe } from '@rematter/ui-web';
import omit from 'lodash/omit';

import { simplePurchaseOrderFragment } from './fragmentsPurchaseOrder';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type PurchaseOrderRecord = QueryAtomResult<
  typeof purchaseOrderListQueryAtom
>['purchaseOrders'][number];

export const purchaseOrderListQueryAtom = createQueryAtomFactory(
  'customerPortal.purchaseOrders',
  (params: {
    searchTerm?: string;
    pagination?: {
      limit: number;
      offset: number;
    };
  }) => ({
    // For customers, sales orders are purchase orders
    salesOrders: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
        },
        pagination: params.pagination,
      },
      entries: simplePurchaseOrderFragment,
      page: {
        total: true,
      },
    },
  }),
  {
    select: ({ salesOrders: purchaseOrders }) => ({
      total: purchaseOrders.page.total ?? 0,
      purchaseOrders: purchaseOrders.entries.map((po) => ({
        ...omit(po, [
          'documentNumber',
          'counterpartyReferenceNumber',
          'account',
        ]),
        salesOrderNumber: po.documentNumber,
        purchaseOrderNumber: maybe(po.counterpartyReferenceNumber),
        numberOfMaterials: po.lineItems.length,
        supplier: po.account,
        netWeight: sumWeights(
          po.lineItems.map((li) => ({
            value: Number(li.quantity),
            unit: li.unit,
          })),
        ),
      })),
    }),
  },
);
